<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17tF1GF/tc-custom/9783989731790.jpg?1708053172654" alt="This image is the cover for the book The Old English Dramatists, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Old English Dramatists, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "When the rule limiting speeches to an hour was adopted by Congress, which was before most of you were born, an eminent but somewhat discursive person spent more than that measure of time in convincing me that whoever really had anything to say could say it in less. I then and there acquired a conviction of this truth, which has only strengthened with years. Yet whoever undertakes to lecture must adapt his discourse to the law which requires such exercises to be precisely sixty minutes long, just as a certain standard of inches must be reached by one who would enter the army. If one has been studying all his life how to be terse, how to suggest rather than to expound, how to contract rather than to dilate, something like a strain is put upon the conscience by this necessity of giving the full measure of words, without reference to other considerations which a judicious ear may esteem of more importance. Instead of saying things compactly and pithily, so that they may be easily carried away, one is tempted into a certain generosity and circumambience of phrase, which, if not adapted to conquer Time, may at least compel him to turn his glass and admit a drawn game. It is so much harder to fill an hour than to empty one!"</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Russell Lowell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71587898